"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isrtl = exports.isPublicRoom = exports.fontSize = exports.font = exports.i18nextss = exports.stopTalk = exports.startTalk = exports.defaultBackToForType = exports.isDebug = exports.poki = exports.isPoki = exports.isIOS = exports.isAndroid = exports.isDevice = exports.setThemeColor = exports.today = exports.timed = exports.sleep = exports.category = exports.colorForGameType = exports.isWeb = exports.isProd = exports.hideSplashscreen = exports.replaceZeroWithO = exports.vibrate = exports.promisedTimeline = exports.fade = exports.randomColor = exports.left = exports.right = exports.px = exports.BreakPoint = void 0;
const gsap_1 = require("gsap");
const interfaces_1 = require("../../shared/interfaces");
const i18next_1 = __importDefault(require("i18next"));
const lodash_1 = __importStar(require("lodash"));
const settings_1 = require("./config/settings");
const SceneManager_1 = require("./managers/SceneManager");
var BreakPoint;
(function (BreakPoint) {
    BreakPoint[BreakPoint["Box"] = 580] = "Box";
    BreakPoint[BreakPoint["Small"] = 650] = "Small";
    BreakPoint[BreakPoint["Medium"] = 780] = "Medium";
    BreakPoint[BreakPoint["Large"] = 950] = "Large";
})(BreakPoint || (exports.BreakPoint = BreakPoint = {}));
const px = (scaler = 1) => {
    return scaler * window.devicePixelRatio;
};
exports.px = px;
const right = (width, padding = 0, max = settings_1.Settings.maxWidth) => {
    return width / 2 + Math.min(px(max), width) / 2 - px(padding);
};
exports.right = right;
const left = (width, padding = 0, max = settings_1.Settings.maxWidth) => {
    return width / 2 - Math.min(px(max), width) / 2 + px(padding);
};
exports.left = left;
function colorForGameType(type) {
    switch (type) {
        case interfaces_1.GameType.Battle:
        case interfaces_1.GameType.BattleFriends:
        case interfaces_1.GameType.Tutorial:
            return settings_1.Settings.battleColor;
        case interfaces_1.GameType.Speed:
            return settings_1.Settings.speedColor;
        case interfaces_1.GameType.Practice:
            return settings_1.Settings.practiceColor;
        case interfaces_1.GameType.Guess:
        case interfaces_1.GameType.GuessFriends:
            return settings_1.Settings.guessColor;
        case interfaces_1.GameType.Levels:
            return settings_1.Settings.levelsColor;
        default:
            return settings_1.Settings.whiteColor;
    }
}
exports.colorForGameType = colorForGameType;
function randomColor() {
    const letters = '0123456789ABCDEF';
    let color = '0x';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return (0, lodash_1.parseInt)(color, 16);
}
exports.randomColor = randomColor;
function fade(item, to = 0.0, duration = 0.2, delay = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        if (item && !item.destroyed) {
            yield promisedTimeline(gsap_1.gsap.timeline({
                autoRemoveChildren: true,
                delay: delay,
                onStart: () => {
                    if (!item.visible && to > 0) {
                        item.alpha = 0;
                        item.visible = true;
                    }
                },
                onComplete: () => {
                    if (to) {
                        item.visible = true;
                    }
                }
            }).to(item, {
                pixi: {
                    alpha: to
                },
                duration
            }));
            item.visible = to !== 0;
        }
        return item;
    });
}
exports.fade = fade;
function promisedTimeline(tm, inset = null) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield new Promise((resolve) => {
            inset === null || inset === void 0 ? void 0 : inset.add(tm);
            tm.vars.autoRemoveChildren = tm.autoRemoveChildren = true;
            tm.vars.onComplete = () => {
                inset === null || inset === void 0 ? void 0 : inset.delete(tm);
                return resolve(tm);
            };
        });
    });
}
exports.promisedTimeline = promisedTimeline;
function timed(mss) {
    const totalMilli = Math.floor(mss / 1000);
    const totalSeconds = Math.floor(totalMilli / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const milli = totalMilli % 1000;
    let text = '';
    if (minutes > 0) {
        text += i18next_1.default.t('minutes', { count: minutes }) + ' ';
    }
    const count = (seconds || 0) + (milli * .001);
    text += i18next_1.default.t('seconds', { count: parseFloat(count.toFixed(2)) });
    return text;
}
exports.timed = timed;
function today() {
    const currentDate = new Date();
    const utc = new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()));
    utc.setUTCHours(0, 0, 0, 0);
    return utc;
}
exports.today = today;
function category(label, witharticle = true) {
    if (label) {
        const a = witharticle ? i18next_1.default.t('categories.' + label + '.a', {
            defaultValue: ''
        }) : null;
        const lb = i18next_1.default.t('categories.' + label + '.n', {
            defaultValue: label
        });
        const isoa = i18nextss() === settings_1.SentenceStructure.OAV;
        return (a && !isoa ? a + ' ' : '') + lb + (a && isoa ? ' ' + a : '');
    }
    return null;
}
exports.category = category;
function i18nextss() {
    switch (i18next_1.default.language || 'en') {
        case 'ja':
            return settings_1.SentenceStructure.OAV;
        case 'hi':
        case 'tr':
            return settings_1.SentenceStructure.AOV;
        default:
            return settings_1.SentenceStructure.VAO;
    }
}
exports.i18nextss = i18nextss;
function isrtl() {
    return i18next_1.default.language === 'ar';
}
exports.isrtl = isrtl;
function sleep(s = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield new Promise((resolve) => {
            lodash_1.default.delay(() => {
                return resolve();
            }, s * 1000);
        });
    });
}
exports.sleep = sleep;
function setThemeColor(color = settings_1.Settings.whiteColor) {
    const scolor = '#' + (color instanceof Array ? color[0] : color).toString(16);
    if (isDevice() && (window === null || window === void 0 ? void 0 : window.StatusBar)) {
        window.StatusBar.backgroundColorByHexString(scolor);
    }
    else if (document === null || document === void 0 ? void 0 : document.querySelector) {
        document.querySelector("meta[name='theme-color']")
            .setAttribute("content", scolor);
    }
    // Just in case there are some stray pixels not over our container
    document.body.style.background = scolor;
}
exports.setThemeColor = setThemeColor;
function defaultBackToForType(type) {
    switch (type) {
        case interfaces_1.GameType.BattleFriends:
        case interfaces_1.GameType.Practice:
            return SceneManager_1.Scenes.Others;
        case interfaces_1.GameType.Levels:
            return SceneManager_1.Scenes.Levels;
        default:
            return SceneManager_1.Scenes.Home;
    }
}
exports.defaultBackToForType = defaultBackToForType;
function startTalk(text) {
    if (text && ('speechSynthesis' in window)) {
        const msg = new SpeechSynthesisUtterance();
        // We can try different voices here if we like
        msg.text = text;
        msg.volume = 0.8;
        // msg.rate = 0.47; // Use default rate
        msg.pitch = 1.13;
        msg.lang = i18next_1.default.language || 'en';
        window.speechSynthesis.speak(msg);
    }
}
exports.startTalk = startTalk;
function font(lang = i18next_1.default.language) {
    const factor = settings_1.FontFactor[lang] || null;
    return (factor === null || factor === void 0 ? void 0 : factor.font) || settings_1.Settings.font;
}
exports.font = font;
function fontSize(size, lang = i18next_1.default.language) {
    const factor = settings_1.FontFactor[lang];
    if (factor) {
        size = size * factor.size;
    }
    return px(size);
}
exports.fontSize = fontSize;
function stopTalk() {
    if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
    }
}
exports.stopTalk = stopTalk;
function replaceZeroWithO(number) {
    // Because the 0 looks bad with this current font, change later if using a different font (or remove completely)
    return number === null || number === void 0 ? void 0 : number.toString().replace(/0/g, 'o');
}
exports.replaceZeroWithO = replaceZeroWithO;
function vibrate() {
    if (navigator === null || navigator === void 0 ? void 0 : navigator.vibrate) {
        navigator.vibrate(settings_1.Settings.vibrateLength);
        return true;
    }
    return false;
}
exports.vibrate = vibrate;
function hideSplashscreen() {
    if (isDevice() && navigator.splashscreen) {
        return new Promise((resolve) => {
            setTimeout(function () {
                navigator.splashscreen.hide();
                return resolve();
            }, 1); // Timeout hack for iOS
        });
    }
    return Promise.resolve();
}
exports.hideSplashscreen = hideSplashscreen;
function isPublicRoom(room) {
    return (room === null || room === void 0 ? void 0 : room.type) === interfaces_1.GameType.Battle || (room === null || room === void 0 ? void 0 : room.type) === interfaces_1.GameType.Guess;
}
exports.isPublicRoom = isPublicRoom;
function isDevice() {
    return isIOS() || isAndroid();
}
exports.isDevice = isDevice;
function isIOS() {
    return process.env.PLATFORM === 'ios';
}
exports.isIOS = isIOS;
function isAndroid() {
    return process.env.PLATFORM === 'android';
}
exports.isAndroid = isAndroid;
function isPoki() {
    return process.env.PLATFORM === 'poki';
}
exports.isPoki = isPoki;
function isWeb() {
    return process.env.PLATFORM === 'browser';
}
exports.isWeb = isWeb;
function isProd() {
    return process.env.NODE_ENV === 'production';
}
exports.isProd = isProd;
function isDebug() {
    return !!(localStorage.getItem('_debug'));
}
exports.isDebug = isDebug;
function poki() {
    return isPoki() ? ((window === null || window === void 0 ? void 0 : window.PokiSDK) || null) : null;
}
exports.poki = poki;
